import {IsoWeekDay} from '@hconnect/uikit'
import {Moment} from 'moment-timezone'

import {DayTime} from './atomic.types'

export type ShiftInput = {
  name: string
  start: DayTime
  end: DayTime
  weekDays: IsoWeekDay[]
}

export interface ShiftDto extends ShiftInput {
  id: number
  endTechnical: DayTime
  endTechnicalUTC: DayTime
  endUTC: DayTime
  startUTC: DayTime
}

export interface ParticularShift extends Shift {
  startDate: Moment
  endDate: Moment
}

export type Shift = Omit<ShiftDto, 'endUTC' | 'endTechnicalUTC' | 'startUTC'>

export class ShiftNotFoundError extends Error {
  readonly code = 'SHIFT_NOT_FOUND'
  readonly name = 'ShiftNotFoundError'

  constructor(message = 'Failed to find a shift for the given date') {
    super(message)
  }
}
